var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingMonthly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_2022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 22.5561C18.1195 22.5561 23.0807 17.5948 23.0807 11.4748C23.0807 5.3548 18.1195 0.393555 11.9995 0.393555C5.87949 0.393555 0.918243 5.3548 0.918243 11.4748C0.918243 17.5948 5.87949 22.5561 11.9995 22.5561Z",
    fill: "url(#paint0_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 22.5561C18.1195 22.5561 23.0807 17.5948 23.0807 11.4748C23.0807 5.3548 18.1195 0.393555 11.9995 0.393555C5.87949 0.393555 0.918243 5.3548 0.918243 11.4748C0.918243 17.5948 5.87949 22.5561 11.9995 22.5561Z",
    fill: "url(#paint1_radial_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9651 9.86211C21.0432 7.92148 18.587 5.50273 18.4839 5.49805C18.4698 5.31523 18.3198 5.17461 18.137 5.17461C17.9448 5.17461 17.7901 5.3293 17.7901 5.52148C17.7901 5.61523 17.8276 5.69961 17.8886 5.76523L16.0042 7.56055C15.9714 7.54648 12.5261 4.00742 12.3526 3.99336C12.3386 3.81055 12.1886 3.66992 12.0057 3.66992C11.8136 3.66992 11.6589 3.82461 11.6589 4.0168C11.6589 4.14336 11.7245 4.25586 11.8276 4.3168L9.30574 8.46992C9.25418 8.42773 6.39481 5.5168 6.22137 5.50273C6.20731 5.31992 6.05731 5.1793 5.87449 5.1793C5.68231 5.1793 5.52762 5.33398 5.52762 5.52617C5.52762 5.70898 5.66824 5.85898 5.85106 5.87305C5.85574 5.96211 6.94324 12.923 6.94324 12.923H6.70887C6.43231 12.923 6.20731 13.148 6.20731 13.4246V14.5309C6.20731 14.7559 6.35262 14.9434 6.55418 15.009C6.58231 15.0934 10.4729 19.0121 13.862 22.3918C19.1026 21.5105 23.0964 16.9543 23.0964 11.4652C23.0776 10.9262 23.0401 10.3871 22.9651 9.86211Z",
    fill: "url(#paint2_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8239 8.67598L11.9974 4.0166L9.17083 8.67598L5.86145 5.52598L6.92551 12.9275H17.0693L18.1333 5.52598L14.8239 8.67598Z",
    fill: "url(#paint3_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 11.0062C12.4853 11.0062 12.8798 10.3683 12.8798 9.58125C12.8798 8.79424 12.4853 8.15625 11.9986 8.15625C11.5119 8.15625 11.1173 8.79424 11.1173 9.58125C11.1173 10.3683 11.5119 11.0062 11.9986 11.0062Z",
    fill: "url(#paint4_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3001 15.042H6.697C6.42043 15.042 6.19543 14.817 6.19543 14.5404V13.4342C6.19543 13.1576 6.42043 12.9326 6.697 12.9326H17.3048C17.5814 12.9326 17.8064 13.1576 17.8064 13.4342V14.5404C17.8064 14.817 17.5814 15.042 17.3001 15.042Z",
    fill: "url(#paint5_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86262 5.87734C6.0542 5.87734 6.2095 5.72204 6.2095 5.53047C6.2095 5.3389 6.0542 5.18359 5.86262 5.18359C5.67105 5.18359 5.51575 5.3389 5.51575 5.53047C5.51575 5.72204 5.67105 5.87734 5.86262 5.87734Z",
    fill: "url(#paint6_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9976 4.36367C12.1892 4.36367 12.3445 4.20837 12.3445 4.0168C12.3445 3.82522 12.1892 3.66992 11.9976 3.66992C11.806 3.66992 11.6507 3.82522 11.6507 4.0168C11.6507 4.20837 11.806 4.36367 11.9976 4.36367Z",
    fill: "url(#paint7_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1322 5.86855C18.3237 5.86855 18.479 5.71325 18.479 5.52168C18.479 5.33011 18.3237 5.1748 18.1322 5.1748C17.9406 5.1748 17.7853 5.33011 17.7853 5.52168C17.7853 5.71325 17.9406 5.86855 18.1322 5.86855Z",
    fill: "url(#paint8_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8115 23.6057H0.186461C0.0364608 23.6057 -0.0572892 23.4322 0.0317733 23.3104L1.93021 20.5869C1.97709 20.5213 1.97709 20.4369 1.93021 20.3713L0.0317733 17.6479C-0.0572892 17.5213 0.0317733 17.3525 0.186461 17.3525H23.8115C23.9615 17.3525 24.0552 17.526 23.9661 17.6479L22.0677 20.3713C22.0208 20.4369 22.0208 20.5213 22.0677 20.5869L23.9661 23.3104C24.0505 23.4369 23.9615 23.6057 23.8115 23.6057Z",
    fill: "url(#paint9_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.067 20.3713L23.9654 17.6479C24.0545 17.5213 23.9654 17.3525 23.8107 17.3525H22.2592C22.4092 17.3525 22.4982 17.526 22.4139 17.6479L20.5154 20.3713C20.492 20.4041 20.4826 20.4416 20.4826 20.4791H22.0295C22.0295 20.4416 22.0436 20.4041 22.067 20.3713Z",
    fill: "url(#paint10_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0671 20.5873C22.0436 20.5545 22.0343 20.517 22.0343 20.4795H20.4827C20.4827 20.517 20.4921 20.5545 20.5155 20.5873L22.4139 23.3107C22.4983 23.4373 22.4093 23.6061 22.2593 23.6061H23.8108C23.9608 23.6061 24.0499 23.4326 23.9655 23.3107L22.0671 20.5873Z",
    fill: "url(#paint11_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.174 22.1758H0.823961L0.0317733 23.3102C-0.0572892 23.4367 0.0317733 23.6055 0.186461 23.6055H23.8115C23.9615 23.6055 24.0552 23.432 23.9661 23.3102L23.174 22.1758Z",
    fill: "url(#paint12_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.49977 18.3135H23.5013L23.9654 17.6479C24.0545 17.5213 23.9654 17.3525 23.8107 17.3525H0.185708C0.0357075 17.3525 -0.0580425 17.526 0.03102 17.6479L0.49977 18.3135Z",
    fill: "url(#paint13_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93021 20.3713L0.0317733 17.6479C-0.0572892 17.5213 0.0317733 17.3525 0.186461 17.3525H1.73802C1.58802 17.3525 1.49896 17.526 1.58334 17.6479L3.48177 20.3713C3.50521 20.4041 3.51459 20.4416 3.51459 20.4791H1.96771C1.96771 20.4416 1.95365 20.4041 1.93021 20.3713Z",
    fill: "url(#paint14_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93135 20.5873C1.95478 20.5545 1.96416 20.517 1.96416 20.4795H3.51572C3.51572 20.517 3.50635 20.5545 3.48291 20.5873L1.58447 23.3107C1.5001 23.4373 1.58916 23.6061 1.73916 23.6061H0.187596C0.0375956 23.6061 -0.0514669 23.4326 0.0329081 23.3107L1.93135 20.5873Z",
    fill: "url(#paint15_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9639 23.3104L22.0655 20.5869C22.0186 20.5213 22.0186 20.4369 22.0655 20.3713L22.1733 20.2213C21.7983 19.8416 21.278 19.326 21.2218 19.3072C21.1702 19.1807 21.0436 19.0916 20.8983 19.0916H19.7077C19.5155 19.0916 19.3561 19.251 19.3561 19.4432V19.5697C19.328 19.5416 19.1452 19.3447 19.0561 19.3072C19.0186 19.2229 18.953 19.1479 18.8593 19.115C18.6764 19.0447 18.4749 19.1338 18.4046 19.3166L18.1514 19.9729C18.1139 19.9307 17.5327 19.3447 17.453 19.3072C17.3827 19.1338 17.1811 19.0447 17.003 19.115C16.8202 19.1854 16.7311 19.3869 16.8014 19.5697L16.8202 19.6213C16.7827 19.5697 16.5624 19.3447 16.478 19.3119C16.4264 19.1854 16.2999 19.0963 16.1546 19.0963C15.9624 19.0963 15.803 19.2557 15.803 19.4479V19.8463C15.7655 19.776 15.3343 19.3447 15.2499 19.3119C15.1983 19.1854 15.0718 19.0963 14.9264 19.0963H14.2374C13.8671 19.0963 13.553 19.326 13.4264 19.6541C13.3889 19.5885 13.1546 19.3494 13.0655 19.3166C13.0139 19.19 12.8874 19.101 12.7421 19.101C12.5499 19.101 12.3905 19.2604 12.3905 19.4525V19.8416C12.353 19.776 11.9311 19.3541 11.8468 19.3166C11.7952 19.19 11.6686 19.101 11.5233 19.101C11.3311 19.101 11.1718 19.2604 11.1718 19.4525V20.5541C11.1343 20.5025 9.97176 19.3354 9.88738 19.3025C9.83582 19.176 9.70926 19.0869 9.56395 19.0869C9.37176 19.0869 9.21238 19.2463 9.21238 19.4385V19.8697C9.19363 19.8557 8.85613 19.5041 8.78113 19.4525C8.62645 19.2416 8.3827 19.101 8.10145 19.101C7.74051 19.101 7.43582 19.3307 7.31395 19.6447C7.28582 19.6025 6.98113 19.326 6.96238 19.3166C6.93426 19.2557 6.89207 19.1994 6.83113 19.1572C6.66707 19.0494 6.45145 19.0963 6.34363 19.2604L6.03895 19.7291C6.02488 19.7197 5.5702 19.2604 5.5702 19.2604C5.46238 19.0963 5.24676 19.0541 5.0827 19.1572C4.91863 19.265 4.87645 19.4807 4.97957 19.6447L5.01707 19.7057C5.01238 19.7057 5.0077 19.701 5.00301 19.701C4.96551 19.6166 4.7077 19.3588 4.62332 19.3213C4.57176 19.1947 4.4452 19.1057 4.29988 19.1057H3.09988C2.9077 19.1057 2.74832 19.265 2.74832 19.4572V21.5385C2.74832 21.6838 2.83738 21.8104 2.96395 21.8619C2.9827 21.9135 3.90145 22.8416 4.68895 23.6244H23.8093C23.9593 23.6057 24.0483 23.4369 23.9639 23.3104Z",
    fill: "url(#paint16_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29051 19.79C4.4827 19.79 4.64207 19.6307 4.64207 19.4385C4.64207 19.2463 4.4827 19.0869 4.29051 19.0869H3.09988C2.9077 19.0869 2.74832 19.2463 2.74832 19.4385V21.5197C2.74832 21.7119 2.9077 21.8713 3.09988 21.8713H4.29051C4.4827 21.8713 4.64207 21.7119 4.64207 21.5197C4.64207 21.3275 4.4827 21.1682 4.29051 21.1682H3.45145V20.8307H3.85457C4.04676 20.8307 4.20613 20.6713 4.20613 20.4791C4.20613 20.2869 4.04676 20.1275 3.85457 20.1275H3.45145V19.79H4.29051Z",
    fill: "url(#paint17_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8921 21.1682H20.053V20.8307H20.4561C20.6483 20.8307 20.8077 20.6713 20.8077 20.4791C20.8077 20.2869 20.6483 20.1275 20.4561 20.1275H20.053V19.79H20.8921C21.0843 19.79 21.2436 19.6307 21.2436 19.4385C21.2436 19.2463 21.0843 19.0869 20.8921 19.0869H19.7014C19.5093 19.0869 19.3499 19.2463 19.3499 19.4385V21.5197C19.3499 21.7119 19.5093 21.8713 19.7014 21.8713H20.8921C21.0843 21.8713 21.2436 21.7119 21.2436 21.5197C21.2436 21.3275 21.0889 21.1682 20.8921 21.1682Z",
    fill: "url(#paint18_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09129 19.79C8.16629 19.79 8.22723 19.851 8.22723 19.926C8.22723 20.1182 8.3866 20.2775 8.57879 20.2775C8.77098 20.2775 8.93035 20.1182 8.93035 19.926C8.93035 19.4619 8.55535 19.0869 8.09129 19.0869C7.62723 19.0869 7.25223 19.4619 7.25223 19.926V21.0322C7.25223 21.4963 7.62723 21.8713 8.09129 21.8713C8.55535 21.8713 8.93035 21.4963 8.93035 21.0322C8.93035 20.84 8.77098 20.6807 8.57879 20.6807C8.3866 20.6807 8.22723 20.84 8.22723 21.0322C8.22723 21.1072 8.16629 21.1682 8.09129 21.1682C8.01629 21.1682 7.95535 21.1072 7.95535 21.0322V19.926C7.95535 19.851 8.01629 19.79 8.09129 19.79Z",
    fill: "url(#paint19_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7366 19.0869C12.5444 19.0869 12.385 19.2463 12.385 19.4385V20.9104C12.385 21.0557 12.2679 21.1682 12.1272 21.1682C11.9866 21.1682 11.8694 21.051 11.8694 20.9104V19.4385C11.8694 19.2463 11.71 19.0869 11.5179 19.0869C11.3257 19.0869 11.1663 19.2463 11.1663 19.4385V20.9104C11.1663 21.44 11.5975 21.8713 12.1272 21.8713C12.6569 21.8713 13.0882 21.44 13.0882 20.9104V19.4385C13.0882 19.2463 12.9288 19.0869 12.7366 19.0869Z",
    fill: "url(#paint20_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5374 21.1826H9.90457V19.4248C9.90457 19.2326 9.7452 19.0732 9.55301 19.0732C9.36082 19.0732 9.20145 19.2326 9.20145 19.4248V21.5342C9.20145 21.7264 9.36082 21.8857 9.55301 21.8857H10.5374C10.7296 21.8857 10.8889 21.7264 10.8889 21.5342C10.8889 21.342 10.7343 21.1826 10.5374 21.1826Z",
    fill: "url(#paint21_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6514 20.1275H14.2296C14.1358 20.1275 14.0608 20.0525 14.0608 19.9588C14.0608 19.865 14.1358 19.79 14.2296 19.79H14.9139C15.1061 19.79 15.2655 19.6307 15.2655 19.4385C15.2655 19.2463 15.1061 19.0869 14.9139 19.0869H14.2296C13.7468 19.0869 13.3577 19.476 13.3577 19.9588C13.3577 20.4416 13.7468 20.8307 14.2296 20.8307H14.6514C14.7452 20.8307 14.8202 20.9057 14.8202 20.9994C14.8202 21.0932 14.7452 21.1682 14.6514 21.1682H13.8124C13.6202 21.1682 13.4608 21.3275 13.4608 21.5197C13.4608 21.7119 13.6202 21.8713 13.8124 21.8713H14.6514C15.1343 21.8713 15.5233 21.4822 15.5233 20.9994C15.5233 20.5166 15.1343 20.1275 14.6514 20.1275Z",
    fill: "url(#paint22_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1468 19.0869C15.9546 19.0869 15.7952 19.2463 15.7952 19.4385V21.5197C15.7952 21.7119 15.9546 21.8713 16.1468 21.8713C16.3389 21.8713 16.4983 21.7119 16.4983 21.5197V19.4385C16.4983 19.2463 16.3436 19.0869 16.1468 19.0869Z",
    fill: "url(#paint23_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 19.1109C18.6727 19.0406 18.4712 19.1297 18.4009 19.3125L17.9274 20.5453L17.454 19.3125C17.3837 19.1297 17.1821 19.0406 16.9993 19.1109C16.8165 19.1812 16.7274 19.3828 16.7977 19.5656L17.5993 21.6469C17.6509 21.7828 17.7821 21.8719 17.9274 21.8719C18.0727 21.8719 18.204 21.7828 18.2555 21.6469L19.0571 19.5656C19.1274 19.3828 19.0384 19.1812 18.8555 19.1109Z",
    fill: "url(#paint24_linear_388_2022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82278 19.144C6.65872 19.0362 6.44309 19.0831 6.33528 19.2471L5.94622 19.8377L5.55716 19.2471C5.44934 19.0831 5.23372 19.0409 5.06966 19.144C4.90559 19.2471 4.86341 19.4674 4.96653 19.6315L5.51966 20.4799L4.96653 21.3284C4.85872 21.4924 4.90559 21.7081 5.06966 21.8159C5.13059 21.8534 5.19622 21.8721 5.26184 21.8721C5.37434 21.8721 5.48684 21.8159 5.55716 21.7127L5.94622 21.1221L6.33528 21.7127C6.40091 21.8159 6.51341 21.8721 6.63059 21.8721C6.69622 21.8721 6.76184 21.8534 6.82278 21.8159C6.98684 21.7081 7.02903 21.4924 6.92591 21.3284L6.37278 20.4799L6.92591 19.6315C7.02903 19.4674 6.98216 19.2518 6.82278 19.144Z",
    fill: "url(#paint25_linear_388_2022)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_2022",
    x1: 4.25551,
    y1: 3.72862,
    x2: 20.1526,
    y2: 19.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#434862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7668,
    stopColor: "#292D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_388_2022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.596 12.0265) scale(11.9888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#62698C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62698C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_388_2022",
    x1: 9.06612,
    y1: 6.78941,
    x2: 21.1066,
    y2: 18.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7836,
    stopColor: "#1B1E30",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_388_2022",
    x1: 8.07184,
    y1: 4.77012,
    x2: 18.1064,
    y2: 14.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_388_2022",
    x1: 11.9986,
    y1: 8.1697,
    x2: 11.9986,
    y2: 11.2446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6572,
    stopColor: "#DD1C38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE0028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_388_2022",
    x1: 11.9986,
    y1: 12.8664,
    x2: 11.9986,
    y2: 15.0935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6572,
    stopColor: "#DD1C38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE0028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_388_2022",
    x1: 5.86408,
    y1: 5.18331,
    x2: 5.86408,
    y2: 5.93678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_388_2022",
    x1: 11.9976,
    y1: 3.67283,
    x2: 11.9976,
    y2: 4.42634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_388_2022",
    x1: 18.1307,
    y1: 5.17762,
    x2: 18.1307,
    y2: 5.93109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_388_2022",
    x1: -0.292133,
    y1: 15.272,
    x2: 25.0468,
    y2: 26.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_388_2022",
    x1: 21.6776,
    y1: 18.4785,
    x2: 22.9203,
    y2: 19.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#F78100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    stopColor: "#F78100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_388_2022",
    x1: 21.6382,
    y1: 22.4114,
    x2: 22.75,
    y2: 21.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#F78100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    stopColor: "#F78100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_388_2022",
    x1: 11.999,
    y1: 21.4751,
    x2: 11.999,
    y2: 23.8733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#F78100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    stopColor: "#F78100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_388_2022",
    x1: 11.9982,
    y1: 17.2569,
    x2: 11.9982,
    y2: 18.6139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7499,
    stopColor: "#FFEDA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_388_2022",
    x1: 1.09274,
    y1: 19.3179,
    x2: 2.8041,
    y2: 18.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7499,
    stopColor: "#FFEDA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_388_2022",
    x1: 0.971674,
    y1: 21.5271,
    x2: 2.7593,
    y2: 22.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7499,
    stopColor: "#FFEDA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_388_2022",
    x1: 13.372,
    y1: 19.0281,
    x2: 13.372,
    y2: 24.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1224,
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7665,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_388_2022",
    x1: 3.69463,
    y1: 19.1717,
    x2: 3.69463,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_388_2022",
    x1: 20.2973,
    y1: 19.1717,
    x2: 20.2973,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_388_2022",
    x1: 8.09012,
    y1: 19.1717,
    x2: 8.09012,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_388_2022",
    x1: 12.1248,
    y1: 19.1717,
    x2: 12.1248,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_388_2022",
    x1: 10.0452,
    y1: 19.1721,
    x2: 10.0452,
    y2: 22.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_388_2022",
    x1: 14.4437,
    y1: 19.1717,
    x2: 14.4437,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_388_2022",
    x1: 16.1491,
    y1: 19.1717,
    x2: 16.1491,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_388_2022",
    x1: 17.9263,
    y1: 19.1723,
    x2: 17.9263,
    y2: 22.2615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_388_2022",
    x1: 5.94758,
    y1: 19.1725,
    x2: 5.94758,
    y2: 22.2618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D526E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_2022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingMonthly);
export default __webpack_public_path__ + "static/media/pricing-monthly.3393ee238b9bc1b1bcc1e9a2d9c7d661.svg";
export { ForwardRef as ReactComponent };